import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import SeoHead from '../components/SeoHead.jsx';

const PrivacyPolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <style>{`
        header { background-color: rgb(11, 31, 63) !important; }
      `}</style>
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 pt-32 pb-16 sm:px-6 lg:px-8">
        <SeoHead
          title={`${t('privacyPolicy.title')} | Wownautic`}
          description={t('privacyPolicy.intro.p1')}
          canonicalPath="/privacy-policy"
        />
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          {t('privacyPolicy.title')}
        </h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.intro.p1')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.intro.p2')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.responsible.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.responsible.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.dataCollected.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.dataCollected.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.dataUse.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.dataUse.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.retention.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.retention.p1')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.retention.p2')}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.retention.p3')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.legal.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.legal.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.thirdParty.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.thirdParty.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.control.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.control.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.sharing.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.sharing.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.rights.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.rights.p1')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.rights.p2')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.rights.p3')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.rights.p4')}
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.rights.p5')}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.rights.p6')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('privacyPolicy.termsOfUse.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('privacyPolicy.termsOfUse.p1')}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t('privacyPolicy.termsOfUse.p2')}
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
